import React from 'react';
import SEO from '../../../Components/SEO';
import Breadcrumb from '../../../Components/Breadcrumb';
import { FaBookOpen } from 'react-icons/fa';
import './collocations-list.css';

const collocationsImg = '/Images/collocations1.webp';

const GROUPS = [
  {
    verbs: ['have', 'do', 'make'],
    have: [
      'have a bath', 'have a drink', 'have a good time', 'have a haircut',
      'have a holiday', 'have a problem', 'have a relationship', 'have a rest',
      'have lunch', 'have sympathy'
    ],
    do: [
      'do business', 'do nothing', 'do someone a favour', 'do the cooking',
      'do the housework', 'do the shopping', 'do the washing up', 'do your best',
      'do your hair', 'do your homework'
    ],
    make: [
      'make a difference', 'make a mess', 'make a mistake', 'make a noise',
      'make an effort', 'make furniture', 'make money', 'make progress',
      'make room', 'make trouble'
    ]
  },
  {
    verbs: ['take', 'break', 'catch'],
    take: [
      'take a break', 'take a chance', 'take a look', 'take a rest',
      'take a seat', 'take a taxi', 'take an exam', 'take notes',
      "take someone's place", "take someone's temperature"
    ],
    break: [
      'break a habit', 'break a leg', 'break a promise', 'break a record',
      'break a window', "break someone's heart", 'break the ice', 'break the law',
      'break the news to someone', 'break the rules'
    ],
    catch: [
      'catch a ball', 'catch a bus', 'catch a chill', 'catch a cold',
      'catch a thief', 'catch fire', 'catch sight of', "catch someone's attention",
      "catch someone's eye", 'catch the flu'
    ]
  },
  {
    verbs: ['pay', 'save', 'keep'],
    pay: [
      'pay a fine', 'pay attention', 'pay by credit card', 'pay cash',
      'pay interest', "pay someone a compliment", "pay someone a visit", 'pay the bill',
      'pay the price', 'pay your respects'
    ],
    save: [
      'save electricity', 'save energy', 'save money', "save one's strength",
      "save someone a seat", "save someone's life", 'save something to a disk',
      'save space', 'save time', 'save yourself the trouble'
    ],
    keep: [
      'keep a diary', 'keep a promise', 'keep a secret', 'keep an appointment',
      'keep calm', 'keep control', 'keep in touch', 'keep quiet',
      "keep someone's place", 'keep the change'
    ]
  },
  {
    verbs: ['come', 'go', 'get'],
    come: [
      'come close', 'come complete with', 'come direct', 'come early',
      'come first', 'come into view', 'come last', 'come late',
      'come on time', 'come prepared', 'come right back', 'come second',
      'come to a compromise', 'come to a decision', 'come to an agreement',
      'come to an end', 'come to a standstill', 'come to terms with',
      'come to a total of', 'come under attack'
    ],
    go: [
      'go abroad', 'go astray', 'go bad', 'go bald', 'go bankrupt',
      'go blind', 'go crazy', 'go dark', 'go deaf', 'go fishing',
      'go mad', 'go missing', 'go on foot', 'go online', 'go out of business',
      'go overseas', 'go quiet', 'go sailing', 'go to war', 'go yellow'
    ],
    get: [
      'get a job', 'get a shock', 'get angry', 'get divorced', 'get drunk',
      'get frightened', 'get home', 'get lost', 'get married', 'get nowhere',
      'get permission', 'get pregnant', 'get ready', 'get started',
      'get the impression', 'get the message', 'get the sack', 'get upset',
      'get wet', 'get worried'
    ]
  }
];

const CollocationsList = () => (
  <div>
    <SEO
      title="Free English Collocations List"
      description="A reference list of common English collocations grouped by verb: have, do, make, take, break, catch, pay, save, keep, come, go, get."
      name="English Exam Exercises"
      type="article"
      image={collocationsImg}
    />
    <Breadcrumb />

    <div className="collocations-list-container">
      <div className="collocations-list-header">
        <h1><FaBookOpen style={{ marginRight: '8px' }} />Collocations List</h1>
        <p>
          Common word combinations grouped by the verb they use. Use this list to
          sound more natural in English.
        </p>
      </div>

      {GROUPS.map(group => (
        <section key={group.verbs.join('-')} className="collocations-group">
          <h2 className="collocations-group-title">
            {group.verbs.join(' / ')}
          </h2>
          <div className="collocations-columns">
            {group.verbs.map(verb => (
              <div key={verb} className="collocations-column">
                <h3 className="collocations-verb">{verb}</h3>
                <ul className="collocations-list">
                  {group[verb].map((item, i) => (
                    <li key={i} className="collocations-item">{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  </div>
);

export default CollocationsList;